import base from '../dr-base'
import drLayoutPlaceHolder from './dr-layout-placeholder.vue'

const schema = {
  ...base,
  allowInToolbox: false,
  $Type: 'dr-layout-placeholder',
  name: 'Layout Placeholder',
  group: 'Container widgets',
  icon: 'link',
  properties: {
    Name: {
      name: 'vuetifyWidgets.dr-layout-placeholder.name',
      type: 'string',
      default: 'Main'
    }
  }
}

export default {
  schema,
  component: drLayoutPlaceHolder
}
